import { Link } from 'react-router-dom';

export default function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="kroy-logo" className="flex items-center gap-2.5 shrink-0 group">
      <img
        src="/kroy-emblem.png"
        alt="KROY Esports — Kannadiga Royals logo"
        className="w-10 h-10 object-contain transition-transform duration-300 group-hover:scale-110"
      />
      {!compact && (
        <span className="leading-none tracking-tight">
          <span className="text-[#e8173a] font-black italic text-lg">KROY</span>
          <span className="text-white font-black italic text-lg ml-1.5">ESPORTS</span>
        </span>
      )}
    </Link>
  );
}
